import { render, staticRenderFns } from "./CalmPage.vue?vue&type=template&id=60b83b8c&"
import script from "./CalmPage.vue?vue&type=script&lang=js&"
export * from "./CalmPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports